import PrimaryCareOrdersTable from "./components/primaryCareOrdersTable";

const PharmaPrimaryCareTable = () => {
  return (
    <div className="pharma_primary_care__layout h-full w-full bg-primaryGray-16 p-2">
      <div className="pharma_primary_care__inner-container flex h-full flex-col gap-2 overflow-hidden rounded bg-white p-4">
        <div className="pharma_primary_care__heading text-h11 font-bold">
          Primary Care Orders
        </div>
        <div className="pharma_primary_care__table-container flex-1 overflow-auto">
          <PrimaryCareOrdersTable />
        </div>
      </div>
    </div>
  );
};

export default PharmaPrimaryCareTable;
